var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1511B",
    d: "M11.388 11.388H0V0h11.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80CC28",
    d: "M23.962 11.388H12.574V0h11.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ADEF",
    d: "M11.388 23.967H0V12.579h11.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC09",
    d: "M23.962 23.967H12.574V12.579h11.388z"
  }))));
}

export default SvgMicrosoft;